// Get Shopify Token
export const GET_SHOPIFY_TOKEN_REQUEST = 'GET_SHOPIFY_TOKEN_REQUEST';
export const GET_SHOPIFY_TOKEN_DONE = 'GET_SHOPIFY_TOKEN_DONE';
export const GET_SHOPIFY_TOKEN_FAILED = 'GET_SHOPIFY_TOKEN_FAILED';

export const GET_SHOPIFY_TOKEN_RESET = 'GET_SHOPIFY_TOKEN_RESET';
